import { Provider as NiceModalProvider } from '@ebay/nice-modal-react'
import { Outlet, RootRoute } from '@tanstack/router'

import { ErrorPage } from '../components/common'
import CustomerService from '../components/common/customer-service'
import BottomNav from '../components/layouts/bottom-nav'
import useAdsInfo from '../hooks/useAdsInfo'
import useAndroidDownloadBanner from '../hooks/useAndroidDownloadBanner'
import useAnnouncements from '../hooks/useAnnouncements'
import useBrazePageView from '../hooks/useBrazePageView'
import useContinue from '../hooks/useContinue'
import useDepositEvents from '../hooks/useDepositEvents'
import useDimensions from '../hooks/useDimensions'
import useIosDownloadBanner from '../hooks/useIosDownloadBanner'
import useKwaiq from '../hooks/useKwaiq'
import useScrollToTop from '../hooks/useScrollToTop'
import useSettings from '../hooks/useSettings'
import useTheme from '../hooks/useTheme'

export const rootRoute = new RootRoute({
  component: () => {
    const { isDesktop } = useDimensions()
    useTheme()
    useContinue()
    useAnnouncements()
    useScrollToTop()
    useSettings()
    useAndroidDownloadBanner()
    useIosDownloadBanner()
    useKwaiq()
    useBrazePageView()
    useDepositEvents()
    useAdsInfo()

    return (
      <NiceModalProvider>
        <CustomerService />
        <Outlet />
        {!window.ReactNativeWebView &&
          !isDesktop &&
          !location.pathname.includes('/game') && <BottomNav />}
      </NiceModalProvider>
    )
  },
  errorComponent: ErrorPage,
})
